import type { Project } from '@/types';

// Projects data — Arkatechs portfolio projects
export const projects: Project[] = [
  {
    id: 'patrawala-group',
    title: 'Patrawala Group',
    category: 'Corporate Website',
    description: 'A modern digital presence for an industrial materials and construction solutions company.',
    tags: ['Corporate Website', 'UI/UX Design', 'Development'],
    image: '/assets/images/work/patrawala-mockup.png',
    accentColor: '#B08D57',
    year: '2024',
    featured: true,
    client: 'Patrawala Group',
    industry: 'Industrial Materials & Construction Solutions',
    role: 'Website Design & Development',
    liveUrl: 'https://www.patrawalagroup.com/index.html',
    longDescription: 'Arkatechs designed and developed a modern corporate website for Patrawala Group, presenting its industrial capabilities, products, services, facilities and company information through a clean digital experience.',
    whatWeBuilt: [
      'Corporate website',
      'Responsive experience',
      'Company profile',
      'Products & services',
      'Industrial facilities',
      'Contact experience',
      'Structured content',
      'Mobile experience'
    ],
    gallery: [
      '/assets/images/work/patrawala-screen-desktop.jpg',
      '/assets/images/work/patrawala-screen-services.png',
      '/assets/images/work/patrawala-mockup.png'
    ]
  },
  {
    id: 'kulala-sangha',
    title: 'Kulala Sangha',
    category: 'Community Platform',
    description: 'A united digital home and community portal connecting Kulalas across the globe.',
    tags: ['Community Platform', 'UI/UX Design', 'Full-Stack Development'],
    image: '/assets/images/work/kulala-mockup-1.jpg',
    accentColor: '#FF7A00',
    year: '2024',
    featured: true,
    client: 'Kulala Sangha',
    industry: 'Community & Cultural Non-Profit',
    role: 'UI/UX Design & Platform Development',
    liveUrl: 'https://kulalsangha.com/user/home',
    longDescription: 'Arkatechs designed and engineered a modern, welcoming digital platform for Kulala Sangha. The unified portal connects community members worldwide, preserving rich cultural traditions while fostering educational opportunities, youth career growth, and impactful social initiatives.',
    whatWeBuilt: [
      'Community Platform',
      'Responsive Experience',
      'UI/UX Design',
      'Content Architecture',
      'Member Initiatives & Showcase',
      'Mobile Experience'
    ],
    gallery: [
      '/assets/images/work/kulala-mockup-2.jpg',
      '/assets/images/work/kulala-mockup-3.jpg',
      '/assets/images/work/kulala-mockup-4.jpg'
    ]
  },
  {
    id: 'kulala-shadi',
    title: 'Kulala Shaadi',
    category: 'Matrimony Platform & Mobile App',
    description: 'A trusted matrimony platform and mobile application connecting community members to find their life partner.',
    tags: ['Matrimony Platform', 'Mobile App', 'UI/UX Design', 'Full-Stack Development'],
    image: '/assets/images/work/kulala-shadi-3.jpg',
    accentColor: '#E11D48',
    year: '2024',
    featured: false,
    client: 'Kulala Shaadi',
    industry: 'Matrimony & Social Networking',
    role: 'Mobile App & Web Platform Development',
    liveUrl: 'https://kulalshaadi.com/home',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.kulalashaadi.app',
    longDescription: 'Arkatechs designed and engineered the digital ecosystem for Kulala Shaadi, a dedicated community matrimony platform available on web and mobile. Built with verified matchmaking, secure messaging, matchmaking preference discovery, and an intuitive user experience, the platform brings together tradition and modern technology to help families find meaningful life partnerships.',
    whatWeBuilt: [
      'Android Mobile App',
      'Responsive Web Platform',
      'Verified Profile Management',
      'Match Discovery & Recommendation Engine',
      'Secure Real-Time Messaging',
      'Privacy & Photo Protection Controls',
      'Modern UI/UX Design System',
      'Admin Dashboard & Moderation Tools'
    ],
    gallery: [
      '/assets/images/work/kulala-shadi-3.jpg',
      '/assets/images/work/kulala-shadi-1.jpg',
      '/assets/images/work/kulala-shadi-2.jpg'
    ]
  },
  {
    id: 'nageena-sukoon',
    title: 'Nageena Sukoon',
    category: 'E-Commerce & Brand Website',
    description: 'A modern digital brand presence and product showcase for an established Ayurvedic pharmacy and wellness brand.',
    tags: ['E-Commerce Website', 'UI/UX Design', 'Brand Experience', 'Web Development'],
    image: '/assets/images/work/nageena-sukoon-mockup.jpg',
    accentColor: '#2E7D32',
    year: '2024',
    featured: false,
    client: 'Nageena Ayurvedic Pharmacy',
    industry: 'Ayurvedic Healthcare & Wellness',
    role: 'Website Design & Development',
    liveUrl: 'https://nageenasukoon.com/home',
    longDescription: 'Arkatechs designed and developed a modern digital brand experience for Nageena Ayurvedic Pharmacy Sukoon, a trusted herbal wellness brand established in 1993. The platform highlights their authentic Ayurvedic oils, pain relief solutions, and hair care products through an intuitive digital showcase, inquiry channels, and an engaging mobile-first layout.',
    whatWeBuilt: [
      'Brand Website',
      'Responsive Digital Experience',
      'Product Showcase & Catalog',
      'Direct Inquiry & Ordering Flow',
      'Brand Heritage Storytelling',
      'Mobile-Optimized Architecture',
      'Product Categories & Details',
      'Performance & SEO Foundations'
    ],
    gallery: [
      '/assets/images/work/nageena-sukoon-mockup.jpg',
      '/assets/images/work/nageena-sukoon-screen-web.jpg',
      '/assets/images/work/nageena-sukoon-screen-tablet.jpg'
    ]
  },
  {
    id: 'tilestore-bhiwandi',
    title: 'TileStoreBhiwandi',
    category: 'Single-Page Showcase Website',
    description: 'A sleek, single-page showcase website for a premium tile, sanitaryware, and surface store in Bhiwandi.',
    tags: ['Landing Page', 'Single-Page Website', 'UI/UX Design', 'Web Development'],
    image: '/assets/images/work/tilestore-bhiwandi-mockup-1.jpg',
    accentColor: '#C5A059',
    year: '2024',
    featured: false,
    client: 'Tile Store Bhiwandi',
    industry: 'Architecture, Interior Materials & Surfaces',
    role: 'Landing Page Design & Development',
    liveUrl: 'https://tilestorebhiwandi.in',
    longDescription: 'Arkatechs designed and developed a high-impact, single-page showcase website for TileStoreBhiwandi. Built to highlight premium tiles, sanitaryware, and luxury surface solutions, the static website provides a dark luxury aesthetic, curated product specialization sections, an interactive gallery, and frictionless quote inquiry channels for homeowners, architects, and builders.',
    whatWeBuilt: [
      'Single-Page Website Architecture',
      'Luxury Dark Theme UI/UX',
      'Product Specialization Showcase',
      'Surface & Tile Gallery',
      'Instant Quote & Contact Flow',
      'Responsive Mobile & Tablet Layout',
      'High-Speed Static Delivery',
      'Local Business SEO Foundations'
    ],
    gallery: [
      '/assets/images/work/tilestore-bhiwandi-mockup-1.jpg',
      '/assets/images/work/tilestore-bhiwandi-mockup-2.jpg',
      '/assets/images/work/tilestore-bhiwandi-mockup-3.jpg'
    ]
  }
];
